import React, { useEffect, useRef, useState } from "react";
import {
  Table,
  Input,
  Select,
  Button,
  Breadcrumb,
  message,
  Divider,
  Row,
  Col,
  Card,
  Grid,
  InputNumber,
} from "antd";
import { PlusOutlined, DeleteOutlined, RightOutlined } from "@ant-design/icons";
import COLORS from "common/Colors";
import styled from "styled-components";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import { getClientid, getUserInfo } from "redux/selectors";
import { find, uniqBy } from "lodash";
import { isDateBetweenTwoDates } from "utils/Date";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import holiday from "pages/holiday";

dayjs.extend(isoWeek);

const { Option } = Select;
const { useBreakpoint } = Grid;

const AddLogWrap = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .ant-select-selector:hover {
    border-color: #ccc !important;
  }

  .nav_style {
    display: flex;
    align-items: center;
  }

  .product_log {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    color: #636980;
  }

  .adding_log {
    font-size: 16px;
    font-weight: 400;
  }
`;

const StyledTable = styled(Table)`
  table {
    min-width: 1000px;
    table-layout: fixed !important;
  }
  textarea.ant-input {
    border-radius: 10px;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 10px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  .ant-table-cell {
    padding: 10px;
    height: 50px !important;
    border: none;
    // white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .ant-table-thead .ant-table-cell {
    border-right: none !important;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-body
    > table
    > tbody
    > tr
    > td {
    border-right: none;
  }
  .ant-table tfoot > tr > td {
    border: none !important;
  }

  .ant-table-tbody > tr > td {
    border: none;
    border-bottom: 1px solid #f0f0f0 !important;
  }

  .action-icons {
    display: none;
  }
  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 8px;
  }
`;

// 🔹 Generate week days dynamically from selecteddate
const getWeekDays = (selecteddate) => {
  const base = dayjs(selecteddate);
  const start = base.startOf("isoWeek"); // Monday

  return Array.from({ length: 7 }, (_, i) => {
    const d = start.add(i, "day");
    return {
      key: d.format("ddd").toLowerCase(), // mon, tue, wed...
      label: `${d.format("D")} - ${d.format("ddd")}`, // e.g. 22 - Mon
      date: d,
    };
  });
};

// 🔹 Format week range
const weekFormat = (value) => {
  const startOfWeek = dayjs(value).startOf("isoWeek").format("Do MMM YYYY");
  const endOfWeek = dayjs(value).endOf("isoWeek").format("Do MMM YYYY");
  return `${startOfWeek} - ${endOfWeek}`;
};

const AddEditProductLog = ({
  selecteddate,
  setIsAddEdit,
  logDetails,
  setLogDetails,
  isEdit = false,
  userid,
  isCurrentWeek,
  tabId,
  setTabId,
  details,
}) => {
  console.log("logdetails2-->", logDetails);
  const userInfo = useSelector(getUserInfo);
  console.log("userInfo-->", userInfo);
  const screens = useBreakpoint();
  const weekDays = getWeekDays(selecteddate);
  const ClientId = useSelector(getClientid);
  console.log("weekdays-->", weekDays);

  const [dataSource, setDataSource] = useState(
    logDetails || [
      {
        key: Date.now(),
        product: "",
        module: "",
        notes: "",
        mon: 0,
        tue: 0,
        wed: 0,
        thu: 0,
        fri: 0,
        sat: 0,
        sun: 0,
      },
    ]
  );
  console.log("datasource-->", dataSource);
  const [errors, setErrors] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDraftLoading, setIsDraftLoading] = useState(false);
  const [leaveList, setLeaveList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);

  console.log("holidayList-->", holidayList);

  console.log("projectList-->", projectList);

  const submitProductLog = async (status) => {
    // const weekdayTotals = dataSource.reduce(
    //   (acc, row) => {
    //     acc.mon += row.mon || 0;
    //     acc.tue += row.tue || 0;
    //     acc.wed += row.wed || 0;
    //     acc.thu += row.thu || 0;
    //     acc.fri += row.fri || 0;
    //     return acc;
    //   },
    //   { mon: 0, tue: 0, wed: 0, thu: 0, fri: 0 }
    // );

    // const hasWeekdayData =
    //   weekdayTotals.mon > 0 &&
    //   weekdayTotals.tue > 0 &&
    //   weekdayTotals.wed > 0 &&
    //   weekdayTotals.thu > 0 &&
    //   weekdayTotals.fri > 0;

    // if (!hasWeekdayData && status === "submit") {
    //   message.error("Please log hours for at least one weekday (Mon–Fri).");
    //   return false;
    // }
    if (status === "submit") {
      setIsLoading(true);
    } else if (status === "draft") {
      setIsDraftLoading(true);
    }
    const { statusCode } = await CALL_API(
      details?.p_logid
        ? `productLogUpdate/${ClientId}/${details?.p_logid}`
        : `productLogCreate/${ClientId}`,
      details?.p_logid ? "patch" : "post",
      {
        userid: userid,
        week: `${dayjs(selecteddate).year()}-W${dayjs(selecteddate).isoWeek()}`,
        status: status,
        selected_date: selecteddate,
        productcount: uniqBy(
          dataSource?.map((item) => {
            return {
              value: item?.product,
            };
          }),
          "value"
        )?.length,
        daysworked: weekDays.filter((d) =>
          dataSource.some((row) => Number(row[d.key]) > 0)
        )?.length,
        submitedon: status === "submit" ? new Date() : new Date(),
        totalhours: dataSource?.reduce(
          (total, row) =>
            total +
            weekDays?.reduce((sum, d) => sum + (Number(row[d.key]) || 0), 0),
          0
        ),
        updatedon: new Date(),
        product_log: dataSource?.map((item) => {
          return { ...item, moduleId: item?.module, productId: item?.product };
        }),
      }
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setIsLoading(false);
      setIsDraftLoading(false);
      setTabId(tabId);
      setIsAddEdit(false);
    } else {
      message?.error("Something went wrong. Please try again.");
    }
  };

  const getHolidayList = async () => {
    const startOfWeek = dayjs(selecteddate)
      .startOf("isoWeek")
      .format("YYYY-MM-DD");
    const endOfWeek = dayjs(selecteddate).endOf("isoWeek").format("YYYY-MM-DD");
    const response = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: startOfWeek,
      end_date: endOfWeek,
    });
    setHolidayList(
      response?.filter((item) =>
        item?.location_id?.includes(userInfo?.baseLocationId)
      )
    );
  };

  const getLeaveList = async () => {
    const startOfWeek = dayjs(selecteddate)
      .startOf("isoWeek")
      .format("YYYY-MM-DD");
    const endOfWeek = dayjs(selecteddate).endOf("isoWeek").format("YYYY-MM-DD");
    const { code, leaves } = await CALL_API(`leave-list/${ClientId}`, "post", {
      status_id: "4,5",
      department_id: [""],
      selected_role_id: "",
      start_date: startOfWeek,
      end_date: endOfWeek,
      show_my_team_leave: false,
    });
    if (code === STATUS_CODE.SUCCESS) {
      setLeaveList(leaves?.filter((val) => val?.userid === userid));
    }
  };

  const getProjectList = async () => {
    setLoading(true);
    const { statusCode, response } = await CALL_API(
      `projectListGet`,
      "get",
      {}
    );
    if (statusCode === STATUS_CODE.SUCCESS) {
      setProjectList(response);
      setLoading(false);
    }
  };

  const getModuleList = async () => {
    setLoading(true);
    const { statusCode, response } = await CALL_API(`moduleListGet`, "get", {});
    if (statusCode === STATUS_CODE.SUCCESS) {
      setModuleList(response);
      setLoading(false);
    }
  };

  const validateRows = () => {
    const newErrors = {};
    dataSource.forEach((row) => {
      const rowErrors = {};
      // Product, Module, Notes required
      if (!row.product) rowErrors.product = true;
      if (!row.module) rowErrors.module = true;
      if (!row.notes) rowErrors.notes = true;
      // Notes max 100 chars
      if (row.notes && row.notes.length > 100) rowErrors.notes = true;
      // Day columns max 24
      weekDays.forEach((day) => {
        if (Number(row[day.key]) > 24) {
          if (!rowErrors.days) rowErrors.days = {};
          rowErrors.days[day.key] = true;
        }
      });
      if (Object.keys(rowErrors).length > 0) newErrors[row.key] = rowErrors;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const tableRef = useRef(null);

  // 🔹 Calculate total row values
  const calculateTotal = () => {
    const totals = {};
    weekDays?.forEach((day) => {
      totals[day.key] = dataSource?.reduce(
        (sum, row) => sum + (Number(row[day?.key]) || 0),
        0
      );
    });
    totals.total = Object.values(totals)?.reduce((a, b) => a + b, 0);
    return totals;
  };

  const handleChange = (value, key, column) => {
    const newData = [...dataSource];
    const row = newData.find((item) => item.key === key);
    row[column] = value;
    setDataSource(newData);
  };

  const handleAdd = () => {
    if (dataSource?.length === 20) {
      message.error("You can add maximum 20 rows only");
      return;
    }
    setDataSource((prev) => {
      const newData = [
        ...prev,
        {
          key: Date.now(),
          product: "",
          module: "",
          notes: "",
          mon: 0,
          tue: 0,
          wed: 0,
          thu: 0,
          fri: 0,
          sat: 0,
          sun: 0,
        },
      ];
      setTimeout(() => {
        const tableBody = tableRef.current?.querySelector(".ant-table-body");
        if (tableBody) {
          tableBody.scrollTop = tableBody.scrollHeight;
        }
      }, 120);
      return newData;
    });
  };

  const handleDelete = (key) => {
    setDataSource(dataSource.filter((item) => item.key !== key));
  };

  // 🔹 Define columns dynamically
  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Select
            style={{
              width: "100%",
              border: errors[record.key]?.product ? "1px solid red" : undefined,
              borderRadius: "10px",
              // boxShadow: errors[record.key]?.product
              //   ? "0 0 0 2px #ffccc7"
              //   : undefined,
            }}
            value={value}
            options={projectList?.map((val) => {
              return { label: val?.product_name, value: val?.product_id };
            })}
            onChange={(val) => {
              handleChange(val, record.key, "product");
              if (errors[record.key]?.product) {
                setErrors((prev) => ({
                  ...prev,
                  [record.key]: { ...prev[record.key], product: false },
                }));
              }
            }}
          />
        ) : (
          projectList?.find((val) => val?.product_id === value)?.product_name ||
          "-"
        ),
    },
    {
      title: "Module",
      dataIndex: "module",
      width: "200px",
      render: (value, record) =>
        isEdit ? (
          <Select
            style={{
              width: "100%",
              border: errors[record.key]?.module ? "1px solid red" : undefined,
              borderRadius: "10px",
              // boxShadow: errors[record.key]?.module
              //   ? "0 0 0 2px #ffccc7"
              //   : undefined,
            }}
            value={value}
            options={moduleList
              ?.filter((item) => item?.product_id === record?.product)
              .map((val) => {
                return { label: val?.module_name, value: val?.module_id };
              })}
            disabled={record?.product === ""}
            onChange={(val) => {
              handleChange(val, record.key, "module");
              if (errors[record.key]?.module) {
                setErrors((prev) => ({
                  ...prev,
                  [record.key]: { ...prev[record.key], module: false },
                }));
              }
            }}
          />
        ) : (
          moduleList?.find((val) => val?.module_id === value)?.module_name ||
          "-"
        ),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      width: "200px",
      borderRadius: "10px",
      render: (value, record) => {
        const isError = errors[record.key]?.notes;
        const isTooLong = value && value.length > 100;
        return isEdit ? (
          <>
            <Input.TextArea
              autoSize={{ minRows: 1, maxRows: 6 }}
              value={value}
              placeholder="Enter notes"
              style={{
                width: "100%",
                borderColor: isError || isTooLong ? "red" : undefined,
                // boxShadow: isError ? "none" : undefined,
              }}
              maxLength={120}
              onChange={(e) => {
                handleChange(e.target.value, record.key, "notes");
                if (errors[record.key]?.notes) {
                  setErrors((prev) => ({
                    ...prev,
                    [record.key]: { ...prev[record.key], notes: false },
                  }));
                }
              }}
            />
            <div style={{ color: isTooLong ? "red" : "#999", fontSize: 12 }}>
              {isTooLong && `Maximum 100 characters`}
            </div>
          </>
        ) : (
          <div className="word-wrap">{value}</div>
        );
      },
    },
    ...weekDays.map((day) => ({
      title: day.label,
      dataIndex: day.key,
      width: "100px",
      align: "center",
      render: (value, record) => {
        const dayOfWeek = day?.date?.day();
        console.log("dayofweek-->", dayOfWeek);
        const isError = errors[record.key]?.days?.[day.key];
        const isTooLongTime = value && value > 24;

        const isValidDateValue = (val) => val && val !== "null" && val !== "";
        // find leave for this day

        const HolidayMatch = holidayList?.find((holiday) => {
          return (
            day?.date.format("YYYY-MM-DD") >= holiday?.start_date &&
            day?.date.format("YYYY-MM-DD") <= holiday?.end_date
          );
        });

        const leaveMatch = leaveList?.find((leave) => {
          const startDate = isValidDateValue(leave.new_start_date)
            ? leave.new_start_date
            : leave.start_date;

          const endDate = isValidDateValue(leave.new_end_date)
            ? leave.new_end_date
            : leave.end_date;

          return (
            day?.date.format("YYYY-MM-DD") >= startDate &&
            day?.date.format("YYYY-MM-DD") <= endDate
          );
        });

        if (isEdit) {
          return (
            <Input
              type="number"
              min={0}
              max={2}
              value={value}
              // onChange={(e) =>
              //   handleChange(Number(e.target.value || 0), record.key, day.key)
              // }
              onChange={(e) => {
                const val = Number(e.target.value || 0);
                if (val <= 24) {
                  handleChange(val, record.key, day.key);
                }
              }}
              style={{
                width: "100%",
                borderRadius: "10px",
                borderColor:
                  isError || isTooLongTime
                    ? "red"
                    : HolidayMatch && leaveMatch?.holiday !== "No"
                    ? "red"
                    : ((HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek !== 6 &&
                        dayOfWeek !== 0) ||
                        (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 6 &&
                          leaveMatch?.isSaturday === "Yes") ||
                        (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 0 &&
                          leaveMatch?.weekend === "Yes") ||
                        (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                      (leaveMatch?.having_cancel_request === "1" ||
                        leaveMatch?.status_id === "4")
                    ? "orange"
                    : ((HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek !== 6 &&
                        dayOfWeek !== 0) ||
                        (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 6 &&
                          leaveMatch?.isSaturday === "Yes") ||
                        (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                        (HolidayMatch &&
                          leaveMatch?.holiday === "Yes" &&
                          dayOfWeek === 0 &&
                          leaveMatch?.weekend === "Yes") ||
                        (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                      leaveMatch?.status_id === "5"
                    ? "green"
                    : undefined,
              }}
            />
          );
        }

        if (leaveMatch || HolidayMatch) {
          // determine border color
          let borderColor = "transparent";
          if (leaveMatch?.holiday !== "No" && HolidayMatch) {
            borderColor = "red";
          } else if (
            ((HolidayMatch &&
              leaveMatch?.holiday === "Yes" &&
              dayOfWeek !== 6 &&
              dayOfWeek !== 0) ||
              (dayOfWeek !== 6 && dayOfWeek !== 0) ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 6 &&
                leaveMatch?.isSaturday === "Yes") ||
              (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 0 &&
                leaveMatch?.weekend === "Yes") ||
              (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
            (leaveMatch?.having_cancel_request === "1" ||
              leaveMatch?.status_id === "4")
          ) {
            borderColor = "orange"; // pending or cancel request
          } else if (
            ((HolidayMatch &&
              leaveMatch?.holiday === "Yes" &&
              dayOfWeek !== 6 &&
              dayOfWeek !== 0) ||
              (dayOfWeek !== 6 && dayOfWeek !== 0) ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 6 &&
                leaveMatch?.isSaturday === "Yes") ||
              (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
              (HolidayMatch &&
                leaveMatch?.holiday === "Yes" &&
                dayOfWeek === 0 &&
                leaveMatch?.weekend === "Yes") ||
              (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
            leaveMatch?.status_id === "5"
          ) {
            borderColor = "green"; // approved
          }

          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: 25,
                  height: 25,
                  borderRadius: "50%",
                  border: `1px solid ${borderColor}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: 500,
                }}
              >
                {value}
              </div>
            </div>
          );
        }

        return value;
      },
    })),

    {
      title: "Total",
      dataIndex: "total",
      align: "center",
      width: "100px",
      render: (_, record) => {
        const rowTotal = weekDays?.reduce(
          (sum, d) => sum + (Number(record[d.key]) || 0),
          0
        );
        return <b>{rowTotal}</b>;
      },
    },
    {
      title: "",
      dataIndex: "action",
      align: "center",
      width: "50px",
      render: (_, record) => {
        return (
          isEdit && (
            <Trash
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(record.key)}
            />
          )
        );
      },
    },
  ];

  const totalRow = calculateTotal();

  const handleSubmit = () => {
    if (validateRows()) {
      // ...submit logic here...
      // Optionally clear errors after successful submit
      setErrors({});
      message.success("Submitted successfully!");
    }
  };

  useEffect(() => {
    getProjectList();
    getModuleList();
  }, []);
  useEffect(() => {
    getLeaveList();
    getHolidayList();
  }, [selecteddate]);

  // Example: weekDays = [{ key: "mon" }, { key: "tue" }, ...]
  const row = dataSource[0]; // single row case, or loop over all if multiple

  const weekStart = weekDays[0].date.startOf("day");
  const weekEnd = weekDays[6].date.endOf("day");

  const leaveInWeek = leaveList
    ?.filter(
      (val) => val?.status_id === "5" && val?.having_cancel_request === "0"
    )
    ?.reduce((sum, d) => {
      const start = dayjs(
        d?.new_start_date &&
          d?.new_start_date !== "null" &&
          d?.new_start_date !== ""
          ? d.new_start_date
          : d.start_date
      );

      const end = dayjs(
        d?.new_end_date && d?.new_end_date !== "null" && d?.new_end_date !== ""
          ? d.new_end_date
          : d.end_date
      );

      // overlap with current week
      const overlapStart = start.isAfter(weekStart) ? start : weekStart;
      const overlapEnd = end.isBefore(weekEnd) ? end : weekEnd;

      if (overlapStart.isAfter(overlapEnd)) return sum; // no overlap

      // ✅ check if current day is holiday
      const isHoliday = holidayList?.some((holiday) => {
        return (
          overlapStart.format("YYYY-MM-DD") >= holiday?.start_date &&
          overlapStart.format("YYYY-MM-DD") <= holiday?.end_date
        );
      });

      // ✅ handle half-day
      if (parseFloat(d?.number_of_days) === 0.5) {
        if (
          (isHoliday && d.holiday === "No") || // exclude if it's a holiday date
          (d?.weekend === "No" && overlapStart.day() === 0) || // Sunday
          (d?.isSaturday === "No" && overlapStart.day() === 6) // Saturday
        ) {
          return sum;
        }
        return sum + 0.5;
      }

      // ✅ handle multi-day leave
      let days = 0;
      for (
        let m = overlapStart.clone();
        m.isSameOrBefore(overlapEnd);
        m = m.add(1, "day")
      ) {
        const dayOfWeek = m.day();

        const isHolidayDay = holidayList?.some((holiday) => {
          return (
            m.format("YYYY-MM-DD") >= holiday?.start_date &&
            m.format("YYYY-MM-DD") <= holiday?.end_date
          );
        });

        if (
          (isHolidayDay && d.holiday === "No") ||
          (dayOfWeek === 6 && d?.isSaturday === "No") ||
          (dayOfWeek === 0 && d?.weekend === "No")
        ) {
          continue;
        }

        days++;
      }

      return sum + days;
    }, 0);

  const data = [
    {
      label: "Products",
      value: uniqBy(
        dataSource?.map((item) => {
          return {
            value: item?.product,
          };
        }),
        "value"
      )?.length,
    },
    {
      label: "Days Worked",
      value: weekDays.filter((d) =>
        dataSource.some((row) => Number(row[d.key]) > 0)
      ).length,
    },
    {
      label: "Leave",
      value: leaveInWeek,
    },
    // {
    //   label: "Leave",
    //   value: leaveList?.reduce((sum, d) => {
    //     let days =
    //       d?.new_number_of_days && d?.new_number_of_days !== "null"
    //         ? Number(d?.new_number_of_days)
    //         : Number(d?.number_of_days);

    //     return sum + (isNaN(days) ? 0 : days);
    //   }, 0),
    // },

    {
      label: "Total Hours",
      value: dataSource?.reduce(
        (total, row) =>
          total +
          weekDays?.reduce((sum, d) => sum + (Number(row[d.key]) || 0), 0),
        0
      ),
    },
  ];

  const footerStyle = {
    position: "absolute",
    bottom: -40,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  return (
    <AddLogWrap>
      <div className="nav_style">
        <p
          className="product_log"
          onClick={() => {
            setLogDetails({});
            setTabId(tabId);
            setIsAddEdit(false);
          }}
        >
          Product Log
        </p>{" "}
        &nbsp;
        <RightOutlined style={{ marginBottom: "12px" }} />
        &nbsp;
        <p className="adding_log">{`${
          isEdit ? "Adding Log" : "Log Details"
        }`}</p>
      </div>
      {!isEdit && (
        <Card
          bordered
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            margin: "20px 0px",
          }}
        >
          <Row align="middle" justify="center" wrap={!screens.md}>
            {data.map((item, index) => (
              <React.Fragment key={item.label}>
                <Col
                  xs={24} // full width in mobile
                  md={6} // 4 equal columns in md and above
                  style={{
                    textAlign: "center",
                    padding: "8px 0",
                  }}
                >
                  <div style={{ color: "#8c8c8c", fontSize: 14 }}>
                    {item.label}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600 }}>
                    {item.value}
                  </div>
                </Col>

                {/* Divider logic */}
                {index < data.length - 1 &&
                  (screens.md ? (
                    // Desktop → vertical divider
                    <Divider type="vertical" style={{ height: "40px" }} />
                  ) : (
                    // Mobile → horizontal divider
                    <Divider style={{ margin: "8px 0" }} />
                  ))}
              </React.Fragment>
            ))}
          </Row>
        </Card>
      )}

      <div className="d-flex justify-content-between align-items-center">
        <b style={{ margin: "16px 0" }}>Week: {weekFormat(selecteddate)}</b>
        <div className="d-flex gap-3 align-items-center">
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid red",
                borderRadius: "50%",
              }}
            ></div>
            <div>Holiday</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid orange",
                borderRadius: "50%",
              }}
            ></div>
            <div>Pending Leave</div>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div
              style={{
                width: "10px",
                height: "10px",
                border: "4px solid green",
                borderRadius: "50%",
              }}
            ></div>
            <div>Approved Leave</div>
          </div>
        </div>
      </div>

      <StyledTable
        ref={tableRef}
        className="mt-2"
        bordered
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        sticky
        scroll={{
          y: "calc(100vh - 380px)",
        }}
        summary={() => (
          <>
            {/* <div style={{ textAlign: "left" }}>
              <Button type="link" icon={<PlusOutlined />} onClick={handleAdd}>
                Add another
              </Button>
            </div> */}
            <Table.Summary className="m-2">
              <Table.Summary.Row
                className="p-2"
                style={{ background: "#d3d9f1", border: "none" }}
              >
                <Table.Summary.Cell index={0}>
                  <b>Total</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} />
                {weekDays.map((d, idx) => {
                  const dayOfWeek = d?.date?.day();
                  const isValidDateValue = (val) =>
                    val && val !== "null" && val !== "";

                  // find holiday for this day
                  const HolidayMatch = holidayList?.find((holiday) => {
                    return (
                      d?.date.format("YYYY-MM-DD") >= holiday?.start_date &&
                      d?.date.format("YYYY-MM-DD") <= holiday?.end_date
                    );
                  });

                  // find leave for this day
                  const leaveMatch = leaveList?.find((leave) => {
                    const startDate = isValidDateValue(leave.new_start_date)
                      ? leave.new_start_date
                      : leave.start_date;

                    const endDate = isValidDateValue(leave.new_end_date)
                      ? leave.new_end_date
                      : leave.end_date;

                    return (
                      d?.date.format("YYYY-MM-DD") >= startDate &&
                      d?.date.format("YYYY-MM-DD") <= endDate
                    );
                  });

                  // determine border color
                  let borderColor = "transparent";
                  if (leaveMatch?.holiday !== "No" && HolidayMatch) {
                    borderColor = "red";
                  } else if (
                    ((HolidayMatch &&
                      leaveMatch?.holiday === "Yes" &&
                      dayOfWeek !== 6 &&
                      dayOfWeek !== 0) ||
                      (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 6 &&
                        leaveMatch?.isSaturday === "Yes") ||
                      (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 0 &&
                        leaveMatch?.weekend === "Yes") ||
                      (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                    (leaveMatch?.having_cancel_request === "1" ||
                      leaveMatch?.status_id === "4")
                  ) {
                    borderColor = "orange"; // pending or cancel request
                  } else if (
                    ((HolidayMatch &&
                      leaveMatch?.holiday === "Yes" &&
                      dayOfWeek !== 6 &&
                      dayOfWeek !== 0) ||
                      (dayOfWeek !== 6 && dayOfWeek !== 0) ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 6 &&
                        leaveMatch?.isSaturday === "Yes") ||
                      (dayOfWeek === 6 && leaveMatch?.isSaturday === "Yes") ||
                      (HolidayMatch &&
                        leaveMatch?.holiday === "Yes" &&
                        dayOfWeek === 0 &&
                        leaveMatch?.weekend === "Yes") ||
                      (dayOfWeek === 0 && leaveMatch?.weekend === "Yes")) &&
                    leaveMatch?.status_id === "5"
                  ) {
                    borderColor = "green"; // approved
                  }

                  return (
                    <Table.Summary.Cell
                      index={3 + idx}
                      key={d.key}
                      align="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <div
                          style={{
                            width: 25,
                            height: 25,
                            borderRadius: "50%",
                            border: `1px solid ${borderColor}`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontWeight: 500,
                          }}
                        >
                          {totalRow[d.key]}
                        </div>
                      </div>
                    </Table.Summary.Cell>
                  );
                })}

                <Table.Summary.Cell index={3 + weekDays.length} align="center">
                  <b>{totalRow.total}</b>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4 + weekDays.length} />
              </Table.Summary.Row>
            </Table.Summary>
          </>
        )}
        footer={
          !isEdit
            ? null
            : () => (
                <div style={{ textAlign: "left" }}>
                  <Button
                    type="link"
                    className="d-flex align-items-center"
                    style={{ color: "#2D53DA" }}
                    icon={<PlusOutlined className="m-0 p -0" />}
                    onClick={handleAdd}
                  >
                    Add another
                  </Button>
                </div>
              )
        }
      />
      {isEdit && (
        <div style={footerStyle}>
          <ButtonOutlined
            onClick={() => {
              setLogDetails({});
              setTabId(tabId);
              setIsAddEdit(false);
            }}
          >
            Cancel
          </ButtonOutlined>
          <ButtonOutlined
            type="primary"
            onClick={() => submitProductLog("draft")}
            loading={isDraftLoading}
            disabled={dataSource?.length === 0}
          >
            Save as Draft
          </ButtonOutlined>
          <ButtonFilled
            type="primary"
            htmlType="submit"
            onClick={() => {
              if (validateRows()) {
                submitProductLog("submit");
              }
            }}
            loading={isLoading}
            disabled={
              dayjs(selecteddate).endOf("isoWeek").isAfter(dayjs(), "day") ||
              dataSource?.length === 0
              // || dayjs(selecteddate).endOf("isoWeek").isSame(dayjs(), "day")
            }
          >
            Submit
          </ButtonFilled>
        </div>
      )}
    </AddLogWrap>
  );
};

export default AddEditProductLog;
